import { Injectable } from "@angular/core";
import { AuthHttpService } from "./auth.http.service";
import { Observable, tap } from "rxjs";
import { Router } from "@angular/router";
import { CurrentUserService } from "./current-user.service";
import { jwtDecode } from "jwt-decode";
import { AuthResponse, LocalStorageKey } from "@model";
import { LocalStorageService } from "../persistance";

@Injectable({ providedIn: "root" })
export class AuthService {
  constructor(
    private _authHttpService: AuthHttpService,
    private _router: Router,
    private _currentUserService: CurrentUserService,
    private _localStorageService: LocalStorageService,
  ) {
    const token = this._localStorageService.get(LocalStorageKey.TOKEN);
    if (token) this.setToken(token);
  }

  private _token: string | null = null;

  getToken() {
    return this._token;
  }

  setToken(token: string): void {
    this._token = token;
    this._localStorageService.set(LocalStorageKey.TOKEN, token);
    this._currentUserService.setCurrentUser(jwtDecode(token));
  }

  clearToken() {
    this._token = null;
    localStorage.removeItem(LocalStorageKey.TOKEN);
    this._currentUserService.clearCurrentUser();
  }

  createUser(name: string, password: string): Observable<AuthResponse> {
    return this._authHttpService.createUser(name, password).pipe(
      tap((authResponse) => {
        this.setToken(authResponse.token);
        this._router.navigate(["main"]);
      }),
    );
  }

  logIn(name: string, password: string): Observable<AuthResponse> {
    return this._authHttpService.logIn(name, password).pipe(
      tap((authResponse) => {
        this.setToken(authResponse.token);
        this._router.navigate(["main"]);
      }),
    );
  }

  logout() {
    this.clearToken();
    this._router.navigate(["auth"]);
  }
}
